// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueMeta from "vue-meta";
import store from './store';
import PeopleDirectory from './components/PeopleDirectory';
import LazyLoadDirective from "./directives/LazyLoadDirective";

Vue.use(VueMeta);

Vue.config.productionTip = false;

Vue.directive("lazyload", LazyLoadDirective);

/* eslint-disable no-new */
new Vue({
  el: '#directory-app',
  components: { PeopleDirectory },
  template: `<PeopleDirectory />`,
  data: store,
  beforeMount: function () {
    this.config = this.getConfig();
  },
  methods: {
    getConfig: function(){
      let config = {
        filters: this.$el.dataset.filters || '',
        source: this.$el.dataset.source || '',
        advanced: '',
        profilePath: (window.tcuglobal.directoryProfilePath) ? window.tcuglobal.directoryProfilePath + '/view' : '/view',
        school: this.$el.dataset.school || '',
        groups: this.$el.dataset.groups || 'none',
      }

      // Advanced is an open field that can be entered into the directory component.
      // It's meant for an object to be passed to it but we need to be very careful about what we actually accept.
      if (this.$el.dataset.advanced) {
        let advanced = JSON.parse(this.$el.dataset.advanced.replace(/'/ig, '"'));
        if (advanced) {
          config.advanced = {
            // baseURL is used to set the base canonical url for a profile if it is different
            // from window.location.host + config.profilePath + /view
            baseURL: ("baseURL" in advanced) ? this.checkBaseURL(advanced.baseURL) : '',
          }
        }
      }

      return config;
    },
    checkBaseURL: function(url) {
      return (url.includes('tcu.edu')) ? url : '';
    }
  },
});



// WEBPACK FOOTER //
// ./src/main.js